import ApiService from "./ApiService"

export async function getCredential (data) {
    return ApiService.fetchData({
        url: '/shiprocket/getCredential',
        method: 'get',
    })
}

export async function updateCredential (data) {
    return ApiService.fetchData({
        url: '/shiprocket/updateCredential',
        method: 'patch',
        data
    })
}

export async function updateCompanyName (data) {
    return ApiService.fetchData({
        url: '/shiprocket/updateCompanyName',
        method: 'patch',
        data
    })
}

export async function generateLabel (data) {
    return ApiService.fetchData({
        url: '/shiprocket/generateLabel',
        method: 'post',
        data
    })
}